<template lang="pug">
    v-toolbar( color="indigo darken-4" dark app absolute clipped-left )
        v-toolbar-side-icon( @click="toggleSidebar()" large )
        v-toolbar-title {{ titleTopBar }}
        v-spacer
        template( v-for="item in items" v-if="items" )
            v-tooltip( bottom v-if="!item.can || $can(item.can)" )
                template( slot="activator" )
                    v-btn(
                      :color="item.color || 'accent'"
                      depressed
                      @click="item.action"
                      )
                        v-icon {{ item.icon }}
                        span &nbsp;{{ item.text }}
                span {{ item.tip }}
        //- v-tooltip( bottom )
        //-     template( slot="activator" )
        //-         v-btn( color="error" depressed )
        //-             v-icon(color="white" @click="logout()") exit_to_app            
        //-     span Salir
        slot(name="logOutSlot")
        //v-badge(class="mr-3" color="white" title="Salir")
            a.ml-0(@click="logout") 
                v-icon(color="white" @click="logoutRequestAction()") exit_to_app
</template>

<script>
import Colors from '@/mixins/Colors'
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
    props: {},
    data() {
        return {}
    },

    computed: {
        ...mapState({
            drawer: state => state.main.drawer,
        }),

        ...mapState('MenuesModule', {
            titleTopBar: 'titleTopBar',
            items: 'items',
        }),
    },

    methods: {
        toggle() {
            this.$emit('toggle')
        },
        logout: function() {
            console.log('logout')
            event.preventDefault()
            this.authLogout()
                .then(() => {
                    this.$router.push('/login')
                })
                .catch(err => {
                    console.log(err)
                    this.$router.push('/login')
                })
        },
        ...mapActions('sidebar', {
            toggleSidebar: 'toggleSidebar',
        }),
        ...mapActions('AuthModule', {
            authLogout: 'logoutRequestAction',
        })
    },

    mixins: { Colors },
}
</script>
